import { createFileRoute, useParams } from '@tanstack/react-router';

import { AnnouncementDetailView } from '@/views/announcements/announcement-detail-view.tsx';

// 详情页；`announcements_` 末尾的 `_` 脱离列表布局。
export const Route = createFileRoute('/_learner/announcements_/$id')({
  component: AnnouncementDetailPage,
});

function AnnouncementDetailPage() {
  const { id } = useParams({ from: '/_learner/announcements_/$id' });
  return <AnnouncementDetailView id={id} />;
}
